import axios from "axios";
import config from "../config/config";

export const getNotifications = async (user_id, token, callback) => {
  try {
    let response = await axios({
      method: "GET",
      url: `${config.server.url}/user/getNotifications`,
      params: {
        user_id,
      },
      headers: { Authorization: `Bearer ${token}` },
    });
    if (response.status === 200) {
      callback(null, response.data);
    }
  } catch (error) {
    if (
      error.response.status === 404 ||
      error.response.status === 500 ||
      error.response.status === 401 ||
      error.response.status === 400
    ) {
      if (error.response.data) {
        callback(error.response.data, null);
      }
    }
  }
};
